import { useApiQuery } from "app/modules/api-client";

import { toSearchAdsSpendListParams } from "./searchAdsSpendParams";
import type { ISearchAdsSpendQueryParams } from "./types";

export interface IUseSearchAdsSpendQueryOptions {
    enabled?: boolean;
}

/**
 * `keys` is optional in the generated params but the endpoint answers an empty list with a 400,
 * so the query stays disabled until at least one domain is requested.
 */
export const useSearchAdsSpendQuery = (
    params: ISearchAdsSpendQueryParams,
    { enabled = true }: IUseSearchAdsSpendQueryOptions = {},
) =>
    useApiQuery(
        {
            tag: "AdSpend",
            methodName: "adintelligenceSearchAdsSpendList",
            options: {
                enabled: enabled && params.keys.length > 0,
                staleTime: Infinity,
            },
        },
        toSearchAdsSpendListParams(params),
    );
